export const VIEW_SETTINGS_SECTION = "viewSettingsSection";
